import { createSlice } from '@reduxjs/toolkit';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import * as Api from "../../api/walletAPI";
import * as UserApi from "../../api/usersAPI";

export const walletSlice = createSlice({
  name: 'wallet',
  initialState: {
    wallets: [],
    status: 'idle',
    pagination: {},
    page: 0,
    rowsPerPage: 100,
    selectedId: null,
    searchValue: '',
    users: [],
    searchStatus: 'idle'
  },
  reducers: {
    setSelectedId: (state, action) => {
      state.selectedId = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setSearchStatus: (state, action) => {
      state.searchStatus = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    getWallets: (state, action) => {
      state.wallets = action.payload;
      state.status = 'success'
    },
  },
});

export const { setSelectedId, setPage, setRowsPerPage, setPagination, getWallets, setSearchValue, setUsers, setSearchStatus } = walletSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.wallet.value)`
export const selectState = state => state.wallet;

export const handleGetWallets = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const state = getState();

  try {
    const res = await Api.getWallets(state.wallet.page, state.wallet.rowsPerPage);
    if (res.error) {
      throw res.error;
    };
    
    const { content, ...pagination } = res;
    let wallets = content;

    dispatch(setPagination(pagination));
    dispatch(getWallets(wallets));
  } catch (err) {
    console.log(err);
  } finally {
    dispatch(hideLoading());
  }
};

export const handleSearchUsers = () => async (dispatch, getState) => {
  const term = (getState().wallet.searchValue || '').trim();

  if (term.length < 2) {
    dispatch(setUsers([]));
    dispatch(setSearchStatus('idle'));
    return;
  }

  dispatch(showLoading());
  dispatch(setSearchStatus('loading'));

  try {
    const users = await UserApi.searchUsersByPartial(term);
    dispatch(setUsers(users));
  } catch (err) {
    console.log(err);
    dispatch(setUsers([]));
  } finally {
    dispatch(setSearchStatus('success'));
    dispatch(hideLoading());
  }
};


export default walletSlice.reducer;
